import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { selectAccountVaultsList } from '../../../redux/programs/selectors';

import mapAccountVaultCardsToItems from '../../../utils/converters/map-account-vault-cards-to-items';

const useDefaultCard = () => {
  const cards = useSelector(selectAccountVaultsList);

  const mappedCards = useMemo(() => cards.map(mapAccountVaultCardsToItems), [
    cards,
  ]);

  const defaultCard = useMemo(() => {
    if (mappedCards && mappedCards.length > 0) {
      return mappedCards.find(
        ({ usedByDefault, isExpired }) => !!usedByDefault && !isExpired,
      );
    }
    return null;
  }, [mappedCards]);

  return {
    defaultCard,
    mappedCards,
  };
};

export default useDefaultCard;



// WEBPACK FOOTER //
// ./src/hooks/payments/account-form/useDefaultCard.js